/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Table } from 'semantic-ui-react';

import styles from './Report.module.scss';

const ReportDetail = React.memo(({ type, energy, opened, dateValue, closeModal }) => {
  const [t] = useTranslation();
  let dataLength = 24;
  const itemsForSelectedDevice = [...energy.settings];

  // console.log('ReportDetail render:');

  let titleReport = t('common.reports.hour');
  switch (type) {
    case 'monthly': {
      const yearValue = new Date(dateValue).getFullYear();
      const monthValue = new Date(dateValue).getMonth();
      dataLength = new Date(yearValue, monthValue + 1, 0).getDate();
      titleReport = t('common.reports.day');
      break;
    }
    case 'yearly': {
      dataLength = 12;
      titleReport = t('common.reports.month');
      break;
    }
    default:
  }

  const renderTableBody = useCallback(() => {
    const dataValue = [];

    if (type === 'daily') {
      for (let i = 0; i <= dataLength - 1; i += 1) {
        const dataItem = [];
        let timeValue = i <= 9 ? `0${i}` : i;
        timeValue += ':00';
        dataItem.id = i;
        dataItem.title = timeValue;
        itemsForSelectedDevice.forEach((item) => {
          dataItem[`${item.itemName}`] = energy[`${item.itemName}`]?.[i];
        });
        dataValue.push({ id: i, value: dataItem });
      }
    } else {
      for (let i = 1; i <= dataLength; i += 1) {
        const dataItem = [];
        const timeValue = i <= 9 ? `0${i}` : i;
        dataItem.id = i;
        dataItem.title = timeValue;
        itemsForSelectedDevice.forEach((item) => {
          dataItem[`${item.itemName}`] = energy[`${item.itemName}`]?.[i - 1];
        });
        dataValue.push({ id: i, value: dataItem });
      }
    }

    let rowId = dataValue.length + 1;
    let dataItem = [];
    dataItem.id = rowId;
    dataItem.title = 'SUM';
    itemsForSelectedDevice.forEach((item) => {
      const setting = energy.settings?.find((element) => element.itemName === item.itemName);
      if (setting.isIntegral) {
        const sumVal = energy[`${item.itemName}`].reduce(
          (sum, current) => (current !== null ? sum + +current : sum),
          null,
        );
        dataItem[`${item.itemName}`] = sumVal;
      } else {
        dataItem[`${item.itemName}`] = null;
      }
    });
    dataValue.push({ id: rowId, value: dataItem });

    rowId += 1;
    dataItem = [];
    dataItem.id = rowId;
    dataItem.title = 'MAX';
    itemsForSelectedDevice.forEach((item) => {
      const maxVal = energy[`${item.itemName}`].reduce(
        (max, current) => (current !== null && current > max ? current : max),
        -Infinity,
      );

      dataItem[`${item.itemName}`] = maxVal === -Infinity ? null : maxVal;
    });
    dataValue.push({ id: rowId, value: dataItem });

    rowId += 1;
    dataItem = [];
    dataItem.id = rowId;
    dataItem.title = 'MIN';
    itemsForSelectedDevice.forEach((item) => {
      const minVal = energy[`${item.itemName}`].reduce(
        (min, current) => (current !== null && current < min ? current : min),
        Infinity,
      );

      dataItem[`${item.itemName}`] = minVal === Infinity ? null : minVal;
    });
    dataValue.push({ id: rowId, value: dataItem });

    rowId += 1;
    dataItem = [];
    dataItem.id = rowId;
    dataItem.title = 'AVG';
    itemsForSelectedDevice.forEach((item) => {
      const arrLength = energy[`${item.itemName}`].filter((f) => f !== null).length;
      const sumVal = energy[`${item.itemName}`]
        .filter((f) => f !== null)
        .reduce((sum, current) => (current !== null ? sum + +current : sum), null);

      dataItem[`${item.itemName}`] = sumVal !== null ? sumVal / arrLength : sumVal;
    });
    dataValue.push({ id: rowId, value: dataItem });

    return (
      <>
        {dataValue.map((dataRow) => {
          return (
            <Table.Row key={dataRow.id}>
              <Table.Cell key={`${dataRow.id}_title`}>{dataRow.value.title}</Table.Cell>
              {itemsForSelectedDevice.map((item) => (
                <Table.Cell key={`${dataRow.id}_${item.itemName}`}>
                  {dataRow.value[`${item.itemName}`] !== null &&
                  !Number.isNaN(dataRow.value[`${item.itemName}`] * 1)
                    ? parseFloat(dataRow.value[`${item.itemName}`]).toLocaleString('en-GB', {
                        minimumFractionDigits: item.decimalPoint,
                        maximumFractionDigits: item.decimalPoint,
                      })
                    : '-'}
                </Table.Cell>
              ))}
            </Table.Row>
          );
        })}
      </>
    );
  }, [energy]);

  return (
    <>
      <Modal closeIcon open={opened} onClose={closeModal} className={styles.modelWrapper}>
        <Modal.Header>
          {t('common.reportDetailed')} : {energy.device.name}
        </Modal.Header>
        <Modal.Content>
          <div className={styles.tableDetailWrapper}>
            <Table singleLine>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell className="uppercase text-xs text-grey">
                    {titleReport}
                  </Table.HeaderCell>
                  {itemsForSelectedDevice.map((item) => (
                    <Table.HeaderCell className="uppercase text-xs text-grey" key={item.itemName}>
                      {item.name}
                    </Table.HeaderCell>
                  ))}
                </Table.Row>
              </Table.Header>
              <Table.Body>{renderTableBody()}</Table.Body>
            </Table>
          </div>
        </Modal.Content>
      </Modal>
    </>
  );
});

ReportDetail.propTypes = {
  type: PropTypes.string.isRequired,
  energy: PropTypes.objectOf(PropTypes.any).isRequired,
  opened: PropTypes.bool.isRequired,
  dateValue: PropTypes.instanceOf(Date).isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default ReportDetail;
